import React, { useEffect, useState } from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { Services } from './components/Services';
import { MembershipSection } from './components/MembershipSection';
import { Why } from './components/Why';
import { Careers } from './components/Careers';
import { Footer } from './components/Footer';
import { MobileCTA } from './components/MobileCTA';
import { Toaster } from './components/ui/sonner';
import { BookingProvider } from './context/BookingContext';
import { DispatchDashboard } from './components/DispatchDashboard';
import { CustomerTracking } from './components/CustomerTracking';
import './App.css';

function App() {
  const [page, setPage] = useState(() => {
    const path = window.location.pathname;
    const params = new URLSearchParams(window.location.search);
    if (path === '/dispatch') return 'dispatch';
    if (path === '/track' && params.get('token')) return 'tracking';
    return 'home';
  });

  const [trackingToken] = useState(() => {
    const params = new URLSearchParams(window.location.search);
    return params.get('token') || null;
  });

  // Handle URL hash routing for Google Ads sitelinks (home page only)
  useEffect(() => {
    if (page !== 'home') return;

    const handleHashNavigation = () => {
      const hash = window.location.hash;
      if (hash) {
        const element = document.querySelector(hash);
        if (element) {
          setTimeout(() => {
            element.scrollIntoView({ behavior: 'smooth' });
          }, 100);
        }
      }
    };

    handleHashNavigation();

    const sections = ['services', 'maintenance-membership', 'pricing', 'why-us', 'careers', 'contact'];

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && entry.intersectionRatio > 0.3) {
            const id = entry.target.id;
            if (id && sections.includes(id)) {
              window.history.replaceState(null, '', `#${id}`);
            }
          }
        });
      },
      { threshold: 0.3 }
    );

    sections.forEach((sectionId) => {
      const element = document.getElementById(sectionId);
      if (element) {
        observer.observe(element);
      }
    });

    return () => observer.disconnect();
  }, [page]);

  // Dispatch Dashboard page
  if (page === 'dispatch') {
    return (
      <>
        <DispatchDashboard />
        <Toaster position="top-center" richColors />
      </>
    );
  }

  // Customer Tracking page
  if (page === 'tracking' && trackingToken) {
    return (
      <>
        <CustomerTracking token={trackingToken} />
        <Toaster position="top-center" richColors />
      </>
    );
  }

  // Main website (home)
  return (
    <BookingProvider>
      <div className="App">
        <Header />
        <main>
          <Hero />
          <Services />
          <MembershipSection />
          <Why />
          <Careers />
        </main>
        <Footer />
        <MobileCTA />
        <Toaster position="top-center" richColors />
      </div>
    </BookingProvider>
  );
}

export default App;
